export const changeBetweenClienteProveedor = ({
  values,
  setFieldValue,
}: $TSMigrationFixMe) => {
  const {
    libradoDireccion,
    libradoEmail,
    libradoNif,
    libradoIban,
    libradoRazonSocial,
    libradoTelefono,
    libradoPais,
    libradoPoblacion,
    libradoPoblacionId,
    libradoCp,

    libradorDireccion,
    libradorEmail,
    libradorNif,
    libradorIban,
    libradorRazonSocial,
    libradorTelefono,
    libradorPais,
    libradorPoblacion,
    libradorPoblacionId,
    libradorCp,
  } = values

  setFieldValue("libradoDireccion", libradorDireccion)
  setFieldValue("libradoEmail", libradorEmail)
  setFieldValue("libradoNif", libradorNif)
  setFieldValue("libradoIban", libradorIban)
  setFieldValue("libradoRazonSocial", libradorRazonSocial)
  setFieldValue("libradoTelefono", libradorTelefono)
  setFieldValue("libradoPais", libradorPais)
  setFieldValue("libradoPoblacion", libradorPoblacion)
  setFieldValue("libradoPoblacionId", libradorPoblacionId)
  setFieldValue("libradoCp", libradorCp)

  setFieldValue("libradorDireccion", libradoDireccion)
  setFieldValue("libradorEmail", libradoEmail)
  setFieldValue("libradorNif", libradoNif)
  setFieldValue("libradorIban", libradoIban)
  setFieldValue("libradorRazonSocial", libradoRazonSocial)
  setFieldValue("libradorTelefono", libradoTelefono)
  setFieldValue("libradorPais", libradoPais)
  setFieldValue("libradorPoblacion", libradoPoblacion)
  setFieldValue("libradorPoblacionId", libradoPoblacionId)
  setFieldValue("libradorCp", libradoCp)
}
